import { navigation } from '@exploration/cms-constants';
import { ADVISOR_URL } from '@exploration/ui-utils';

export const getDefaultData = () => ({
  callToAction: {
    [navigation.products_navigation_links.banking_all_banking]: {
      href: 'http://www.thrivent.com/banking',
      text: 'All Banking',
    },
    [navigation.products_navigation_links.banking_thrivent_bank]: {
      href: 'https://access.thriventbank.com/',
      text: 'Thrivent Bank',
      target: '_blank',
    },
    [navigation.products_navigation_links.banking_church_loans]: {
      href: 'https://www.thriventchurchloans.com/',
      text: 'Church Loans',
      target: '_blank',
    },
    [navigation.products_navigation_links.investments_annuities]: {
      href: 'https://www.thrivent.com/annuities',
      text: 'Annuities',
    },
    [navigation.products_navigation_links.investments_mutual_funds]: {
      href: 'https://www.thrivent.com/investments/mutual-funds',
      text: 'Mutual Funds',
    },
    [navigation.products_navigation_links.insurance_disability_insurance]: {
      href: 'https://www.thrivent.com/insurance/disability-insurance',
      text: 'Disability Insurance',
    },
    [navigation.products_navigation_links.insurance_life_insurance]: {
      href: 'https://www.thrivent.com/insurance/life-insurance',
      text: 'Life Insurance',
    },
    [navigation.products_navigation_links.insurance_long_term_care_strategy]: {
      href: 'https://www.thrivent.com/insurance/long-term-care-insurance',
      text: 'Long Term Care Strategy',
    },
    [navigation.products_navigation_links.all_products_and_services]: {
      href: 'https://thrivent.com/product-overview',
      text: 'All Products & services',
    },
    [navigation.products_promo_card.products_promo_card_call_to_action]: {
      href: ADVISOR_URL,
      text: 'Start your search',
    },
  },
  image: {},
  list: {},
  text: {
    [navigation.products_navigation_links.banking_banking_title]: 'Banking',
    [navigation.products_navigation_links.banking_investments_title]:
      'Investments',
    [navigation.products_navigation_links.banking_insurance_title]: 'Insurance',
    [navigation.products_promo_card.products_promo_card_title]:
      'Find a financial advisor',
    [navigation.products_promo_card.products_promo_card_description]:
      'Get started on your journey to financial confidence today.',
    [navigation.products_navigation_links.products_title]: 'Products',
    [navigation.products_navigation_links.products_description]:
      'See what products our advisors can help with',
  },
  video: {},
});
